import Joi from 'joi';

export const SupportSchema = Joi.object({
  title: Joi.string().required(),
  pined: Joi.string().required(),
  file: Joi.string().required(),
});
